import { ICONS } from "../../constants/icons"
import overviewTabIcon from "../../assets/images/icon/overview-icon.svg"
import sessionTabIcon from "../../assets/images/icon/session-icon.svg"
import myTaskTabIcon from "../../assets/images/icon/my-task-icon.svg"
import calendarTabIcon from "../../assets/images/icon/calendar-icon.svg"
import messagesTabIcon from "../../assets/images/icon/message-text.svg"
import collaboratorTabIcon from "../../assets/images/icon/collaborator-icon.svg"
import avatar1 from "../../assets/images/users/avatar-1.jpg"
import avatar2 from "../../assets/images/users/avatar-2.jpg"
import avatar3 from "../../assets/images/users/avatar-3.jpg"
import avatar4 from "../../assets/images/users/avatar-4.jpg"
import avatar5 from "../../assets/images/users/avatar-5.jpg"
import avatar6 from "../../assets/images/users/avatar-6.jpg"
import avatar7 from "../../assets/images/users/avatar-7.jpg"
import avatar8 from "../../assets/images/users/avatar-8.jpg"

const DESCRIPTION =
  "A multi-day live arts experience celebrating cultural convergence across Dallas. This curated festival unites immersive orchestral music, contemporary dance choreography, large-scale visual installations, and interactive community performances."

export const TABS = [
  { key: "overview", label: "Overview", icon: overviewTabIcon },
  { key: "sessions", label: "Sessions", icon: sessionTabIcon },
  { key: "tasks", label: "All Tasks", icon: ICONS.task },
  { key: "my-tasks", label: "My Tasks", icon: myTaskTabIcon },
  { key: "calendar", label: "Calendar", icon: calendarTabIcon },
  {
    key: "collaborators",
    label: "Collaborators",
    icon: collaboratorTabIcon,
  },
  { key: "messages", label: "Messages", icon: messagesTabIcon },
]

export const PROJECTS = [
  {
    id: "019fd307-18a4-7177-a6d3-9a01309d18e0",
    code: "DA",
    title: "Dallas Live Arts Festival 2026",
    category: "Music",
    status: "upcoming",
    statusLabel: "Up-Coming",
    city: "Dallas, TX",
    startingFrom: "Dec 15, 2025",
    startDate: "Dec 15, 2025",
    endDate: "Mar 22, 2027",
    targetDate: "Mar 22, 2027",
    description: DESCRIPTION,
    createdBy: { name: "Mark Carlo", avatar: avatar1 },
    countdown: { days: 524, hours: 14, minutes: 37, seconds: 52 },
    hours: {
      consumed: 520,
      dedicated: 520,
      perWeek: 120,
      estimatedTotal: 420,
      logged: 210,
      remaining: 120,
    },
    collaborators: [
      {
        name: "Mark Carlo",
        role: "Guitarist",
        avatar: avatar1,
        status: "Online",
      },
      {
        name: "Sophia Lee",
        role: "Photographer",
        avatar: avatar2,
        status: "Online",
      },
      {
        name: "Olivia Chen",
        role: "Producer",
        avatar: avatar7,
        status: "Away",
      },
      {
        name: "Amira Patel",
        role: "Musician",
        avatar: avatar4,
        status: "Online",
      },
      { name: "Ethan Wright", role: "QA", avatar: avatar3, status: "Offline" },
      {
        name: "Liam Jones",
        role: "Designer",
        avatar: avatar5,
        status: "Online",
      },
    ],
    estimatedHours: [
      { name: "Mark Carlo", avatar: avatar1, hours: 7.5 },
      { name: "Emily Chen", avatar: avatar6, hours: 5.5 },
      { name: "Sophia Lee", avatar: avatar2, hours: 6 },
      { name: "Liam O'Connor", avatar: avatar5, hours: 7 },
      { name: "Raj Patel", avatar: avatar8, hours: 8 },
    ],
    sessions: [],
    media: [],
  },
  {
    id: "019fd307-18a4-7177-a6d3-9a01309d18df",
    code: "DA",
    title: "Dallas Live Arts Festival 2026",
    category: "Music",
    status: "in-progress",
    statusLabel: "In-Progress",
    city: "Dallas, TX",
    progress: 62,
    daysLeft: 18,
    collaboratorTotal: 25,
    myTasksProgress: { percent: 75, done: 12, total: 15 },
    startDate: "June 10, 2026",
    targetDate: "Aug 12, 2026",
    endDate: "Aug 12, 2026",
    description: DESCRIPTION,
    createdBy: { name: "Mark Carlo", avatar: avatar1 },
    countdown: { days: 0, hours: 0, minutes: 0, seconds: 0 },
    hours: {
      consumed: 520,
      dedicated: 520,
      perWeek: 120,
      estimatedTotal: 420,
      logged: 210,
      remaining: 120,
    },
    collaborators: [
      {
        name: "Mark Carlo",
        role: "Guitarist",
        avatar: avatar1,
        status: "Online",
      },
      {
        name: "Sophia Lee",
        role: "Photographer",
        avatar: avatar2,
        status: "Online",
      },
      {
        name: "Mark Carlo",
        role: "Guitarist",
        avatar: avatar1,
        status: "Away",
      },
      {
        name: "Amira Patel",
        role: "Musician",
        avatar: avatar4,
        status: "Online",
      },
      { name: "Ethan Wright", role: "QA", avatar: avatar3, status: "Offline" },
      {
        name: "Liam Jones",
        role: "Designer",
        avatar: avatar5,
        status: "Online",
      },
    ],
    estimatedHours: [
      { name: "Mark Carlo", avatar: avatar1, hours: 7.5, progress: 40 },
      { name: "Emily Chen", avatar: avatar6, hours: 5.5, progress: 24 },
      { name: "Sophia Lee", avatar: avatar2, hours: 6, progress: 65 },
      { name: "Liam O'Connor", avatar: avatar5, hours: 7, progress: 12 },
      { name: "Raj Patel", avatar: avatar8, hours: 8, progress: 80 },
    ],
    sessions: [
      {
        id: "wqe213123213-1231-23-123",
        title: "Music Team Warmup Session",
        type: "Shadow Session",
        visibility: "Private",
        note: "Played Guitar for 2 hours",
        startedAt: "June 12, 2025, 3:45 PM",
        startedBy: { name: "Mark Carlo", src: avatar1 },
        sessionNote: "Warming up, reviewing setlist for Friday's gig",
        timer: "00:24:37",
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        logged: "7.5hrs",
        endAt: "June 12, 2025, 3:45 PM",
      },
      {
        id: "session-2",
        type: "Solo Session",
        visibility: "---",
        note: "Played Guitar for 2 hours",
        collaborators: [{ name: "Mark Carlo", src: avatar1 }],
        logged: "6.75hrs",
        endAt: "June 13, 2025, 11:20 AM",
      },
      {
        id: "session-3",
        type: "Shadow Session",
        visibility: "Public",
        note: "Played Guitar for 2 hours",
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        logged: "5.25hrs",
        endAt: "June 14, 2025, 9:05 AM",
      },
      {
        id: "session-4",
        type: "Solo Session",
        visibility: "---",
        note: "Played Guitar for 2 hours",
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        logged: "7.25hrs",
        endAt: "June 15, 2025, 1:30 PM",
      },
      {
        id: "session-5",
        type: "Shadow Session",
        visibility: "Private",
        note: "Played Guitar for 2 hours",
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Amira Patel", src: avatar4 },
        ],
        logged: "4.5hrs",
        endAt: "June 16, 2025, 4:10 PM",
      },
      {
        id: "session-6",
        type: "Solo Session",
        visibility: "---",
        note: "Played Guitar for 2 hours",
        collaborators: [{ name: "Mark Carlo", src: avatar1 }],
        logged: "6.5hrs",
        endAt: "June 17, 2025, 8:55 AM",
      },
      {
        id: "session-7",
        type: "Shadow Session",
        visibility: "Private",
        note: "Played Guitar for 2 hours",
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Amira Patel", src: avatar4 },
        ],
        logged: "7.5hrs",
        endAt: "June 12, 2025, 3:45 PM",
      },
      {
        id: "session-8",
        type: "Solo Session",
        visibility: "---",
        note: "Played Guitar for 2 hours",
        collaborators: [{ name: "Mark Carlo", src: avatar1 }],
        logged: "6.75hrs",
        endAt: "June 13, 2025, 11:20 AM",
      },
      {
        id: "session-9",
        type: "Shadow Session",
        visibility: "Public",
        note: "Played Guitar for 2 hours",
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        logged: "5.25hrs",
        endAt: "June 14, 2025, 9:05 AM",
      },
      {
        id: "session-10",
        type: "Solo Session",
        visibility: "---",
        note: "Played Guitar for 2 hours",
        collaborators: [{ name: "Mark Carlo", src: avatar1 }],
        logged: "6.75hrs",
        endAt: "June 13, 2025, 11:20 AM",
      },
      {
        id: "session-11",
        type: "Shadow Session",
        visibility: "Public",
        note: "Played Guitar for 2 hours",
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Amira Patel", src: avatar4 },
        ],
        logged: "5.25hrs",
        endAt: "June 14, 2025, 9:05 AM",
      },
      {
        id: "session-12",
        type: "Solo Session",
        visibility: "---",
        note: "Played Guitar for 2 hours",
        collaborators: [{ name: "Mark Carlo", src: avatar1 }],
        logged: "7.25hrs",
        endAt: "June 15, 2025, 1:30 PM",
      },
      {
        id: "session-13",
        type: "Shadow Session",
        visibility: "Private",
        note: "Played Guitar for 2 hours",
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        logged: "4.5hrs",
        endAt: "June 16, 2025, 4:10 PM",
      },
      {
        id: "session-14",
        type: "Solo Session",
        visibility: "---",
        note: "Played Guitar for 2 hours",
        collaborators: [{ name: "Mark Carlo", src: avatar1 }],
        logged: "7.25hrs",
        endAt: "June 15, 2025, 1:30 PM",
      },
      {
        id: "session-15",
        type: "Shadow Session",
        visibility: "Public",
        note: "Played Guitar for 2 hours",
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        logged: "3.75hrs",
        endAt: "June 18, 2025, 6:40 PM",
      },
    ],
    media: [],
  },
  {
    id: "019fd307-18a4-7177-a6d3-9a01309d18e1",
    code: "DA",
    title: "Dallas Live Arts Festival 2026",
    category: "Music",
    status: "past",
    statusLabel: "Past Project",
    city: "Dallas, TX",
    completedDate: "Dec 15, 2026",
    startDate: "June 10, 2026",
    endDate: "Dec 15, 2026",
    targetDate: "Dec 15, 2026",
    description: DESCRIPTION,
    createdBy: { name: "Mark Carlo", avatar: avatar1 },
    countdown: { days: 0, hours: 0, minutes: 0, seconds: 0 },
    hours: {
      consumed: 520,
      dedicated: 520,
      perWeek: 120,
      estimatedTotal: 420,
      logged: 520,
      remaining: 0,
    },
    collaborators: [
      {
        name: "Mark Carlo",
        role: "Guitarist",
        avatar: avatar1,
        status: "Offline",
      },
      {
        name: "Tomás Rivera",
        role: "Bassist",
        avatar: avatar7,
        status: "Offline",
      },
      {
        name: "Aisha Patel",
        role: "Violinist",
        avatar: avatar8,
        status: "Offline",
      },
      {
        name: "Sofía Reyes",
        role: "Vocalist",
        avatar: avatar4,
        status: "Offline",
      },
      {
        name: "James Okonkwo",
        role: "Drummer",
        avatar: avatar5,
        status: "Offline",
      },
      {
        name: "Lena Bergström",
        role: "Pianist",
        avatar: avatar6,
        status: "Offline",
      },
    ],
    estimatedHours: [
      { name: "Mark Carlo", avatar: avatar1, hours: 7.5 },
      { name: "Emily Chen", avatar: avatar6, hours: 5.5 },
      { name: "Sophia Lee", avatar: avatar2, hours: 6 },
      { name: "Liam O'Connor", avatar: avatar5, hours: 7 },
      { name: "Raj Patel", avatar: avatar8, hours: 8 },
    ],
    sessions: [],
    media: {
      totalFiles: 9,
      totalSize: "2.4 GB",
      items: [
        { src: avatar1, isVideo: false },
        { src: avatar2, isVideo: true },
        { src: avatar3, isVideo: false },
        { src: avatar4, isVideo: false },
        { src: avatar5, isVideo: true },
        { src: avatar6, isVideo: false },
        { src: avatar7, isVideo: true },
        { src: avatar8, isVideo: false },
        { src: avatar1, isVideo: true },
      ],
    },
  },
]

export const COLLABORATORS = [
  {
    name: "Sophie Chen",
    city: "New York, USA",
    role: "Audio Engineer",
    addedOn: "May 23, 2026",
    status: "Pending",
    avatar: avatar1,
  },
  {
    name: "Carlos Ramirez",
    city: "Mexico City, Mexico",
    role: "Event Coordinator",
    addedOn: "April 30, 2026",
    status: "Rejected",
    avatar: avatar2,
  },
  {
    name: "Elena Petrova",
    city: "Moscow, Russia",
    role: "Data Analyst",
    addedOn: "May 5, 2026",
    status: "Pending",
    avatar: avatar3,
  },
  {
    name: "Jamal Thompson",
    city: "Toronto, Canada",
    role: "Stage Manager",
    addedOn: "June 19, 2026",
    status: "Active",
    avatar: avatar4,
  },
  {
    name: "Liam O'Connor",
    city: "Dublin, Ireland",
    role: "Visual Designer",
    addedOn: "June 12, 2026",
    status: "Active",
    avatar: avatar5,
  },
  {
    name: "Sophie Chen",
    city: "New York, USA",
    role: "Sound Technician",
    addedOn: "May 23, 2026",
    status: "Pending",
    avatar: avatar6,
  },
  {
    name: "Amira Patel",
    city: "Mumbai, India",
    role: "Manager",
    addedOn: "July 2, 2026",
    status: "Active",
    avatar: avatar4,
  },
  {
    name: "Na Johnson",
    city: "Dallas, Texas",
    role: "Marketer",
    addedOn: "July 14, 2026",
    status: "Rejected",
    avatar: avatar7,
  },
  {
    name: "Elena Petrova",
    city: "Moscow, Russia",
    role: "Data Analyst",
    addedOn: "May 5, 2026",
    status: "Pending",
    avatar: avatar3,
  },
  {
    name: "Liam O'Connor",
    city: "Dublin, Ireland",
    role: "Visual Designer",
    addedOn: "June 12, 2026",
    status: "Active",
    avatar: avatar5,
  },
  {
    name: "Sophie Chen",
    city: "New York, USA",
    role: "Sound Technician",
    addedOn: "May 23, 2026",
    status: "Pending",
    avatar: avatar6,
  },
  {
    name: "Amira Patel",
    city: "Mumbai, India",
    role: "Manager",
    addedOn: "July 2, 2026",
    status: "Active",
    avatar: avatar4,
  },
]

export const TASK_GROUPS = [
  {
    id: 1,
    owner: {
      name: "John Smith",
      avatar: avatar1,
      role: "Composer",
      roleTone: "purple",
      isYou: true,
    },
    tasks: [
      {
        id: 101,
        title: "Scope & Prototype Document",
        status: "Completed",
        dueDate: "May 20, 2025",
        estimated: 6,
        logged: 5.5,
        progress: 80,
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        description:
          "Define the full project scope including deliverables, timeline, milestones, and resource allocation. Create interactive prototype for client review.",
        sessionActivity: [
          {
            user: { name: "Jake Rivera", avatar: avatar2 },
            action: "Check in",
            time: "2:00 PM",
            note: "Running through the new bridge section on guitar",
          },
          {
            user: { name: "Jake Rivera", avatar: avatar2 },
            action: "Check out",
            time: "3:45 PM",
            note: "Nailed the bridge, recorded a rough take",
          },
          {
            user: { name: "Mia Thompson", avatar: avatar3 },
            action: "Check in",
            time: "2:30 PM",
            note: "Working on vocal harmonies for track 3",
          },
          {
            user: { name: "Mia Thompson", avatar: avatar3 },
            action: "Active",
            time: "",
            note: "Still in session",
          },
          {
            user: { name: "Diego Santos", avatar: avatar4 },
            action: "Check in",
            time: "1:15 PM",
            note: "Mixing drums for the intro section",
          },
          {
            user: { name: "Diego Santos", avatar: avatar4 },
            action: "Check out",
            time: "3:10 PM",
            note: "Drums balanced, exported stems to shared drive",
          },
          {
            user: { name: "Mia Thompson", avatar: avatar3 },
            action: "Check in",
            time: "11:00 AM",
            note: "Warming up, reviewing setlist for Friday's gig",
          },
          {
            user: { name: "Mia Thompson", avatar: avatar3 },
            action: "Check out",
            time: "12:30 PM",
            note: "Setlist locked in, practiced transitions",
          },
        ],
        timeTracking: { total: 12, logged: 8.5, remaining: 3.5 },
      },
      {
        id: 102,
        title: "Scope & Prototype Document",
        status: "In Progress",
        dueDate: "May 20, 2025",
        estimated: 6,
        logged: 4.5,
        progress: 48,
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        description:
          "Review and clean the act 2 sound mix, fix any clipping or imbalance, and prepare final stems for the mastering pass.",
        sessionActivity: [
          {
            user: { name: "John Smith", avatar: avatar1 },
            action: "Check in",
            time: "10:00 AM",
            note: "Listening to act 2 full mix",
          },
          {
            user: { name: "John Smith", avatar: avatar1 },
            action: "Check out",
            time: "12:30 PM",
            note: "Fixed dialogue overlap in scene 5",
          },
        ],
        timeTracking: { total: 6, logged: 4.5, remaining: 1.5 },
      },
      {
        id: 103,
        title: "Scope & Prototype Document",
        status: "Completed",
        dueDate: "May 20, 2025",
        estimated: 6,
        logged: 6,
        progress: 72,
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        description:
          "Write and record the opening theme that introduces the festival and sets the emotional tone for the show.",
        sessionActivity: [
          {
            user: { name: "John Smith", avatar: avatar1 },
            action: "Check in",
            time: "9:00 AM",
            note: "Sketching opening theme on piano",
          },
          {
            user: { name: "John Smith", avatar: avatar1 },
            action: "Check out",
            time: "11:30 AM",
            note: "Theme recorded with guide strings",
          },
        ],
        timeTracking: { total: 6, logged: 6, remaining: 0 },
      },
    ],
  },
  {
    id: 2,
    owner: {
      name: "Sarah Kim",
      avatar: avatar5,
      role: "Head Designer",
      roleTone: "green",
    },
    tasks: [
      {
        id: 201,
        title: "Sound Design",
        status: "In Progress",
        dueDate: "May 20, 2025",
        estimated: 8,
        logged: 8,
        progress: 72,
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        description:
          "Build the visual design system including color palette, typography, iconography, and component library for all festival materials.",
        sessionActivity: [
          {
            user: { name: "Sarah Kim", avatar: avatar5 },
            action: "Check in",
            time: "1:00 PM",
            note: "Defining color palette with branding team",
          },
          {
            user: { name: "Sarah Kim", avatar: avatar5 },
            action: "Check out",
            time: "3:30 PM",
            note: "Palette approved, token file created",
          },
        ],
        timeTracking: { total: 8, logged: 8, remaining: 0 },
      },
      {
        id: 202,
        title: "Sound Design",
        status: "Not Started",
        dueDate: "May 20, 2025",
        estimated: 8,
        logged: 5.5,
        progress: 48,
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        description:
          "Produce initial stage layout sketches that consider sight lines, lighting positions, and performer movement.",
        sessionActivity: [],
        timeTracking: { total: 8, logged: 5.5, remaining: 2.5 },
      },
    ],
  },
  {
    id: 3,
    owner: {
      name: "Alex Johnson",
      avatar: avatar6,
      role: "Orchestrator",
      roleTone: "blue",
    },
    tasks: [
      {
        id: 301,
        title: "Brass Section Arrangement",
        status: "Completed",
        dueDate: "May 20, 2025",
        estimated: 8,
        logged: 8,
        progress: 100,
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
          { name: "Ethan Wright", src: avatar3 },
        ],
        description:
          "Arrange the brass section for the festival's main stage set, ensuring balance with the rhythm and string sections.",
        sessionActivity: [
          {
            user: { name: "Alex Johnson", avatar: avatar6 },
            action: "Check in",
            time: "2:00 PM",
            note: "Arranging brass stabs for chorus",
          },
          {
            user: { name: "Alex Johnson", avatar: avatar6 },
            action: "Check out",
            time: "5:00 PM",
            note: "Brass score exported",
          },
        ],
        timeTracking: { total: 8, logged: 8, remaining: 0 },
      },
      {
        id: 302,
        title: "String Rehearsal Notes",
        status: "Not Started",
        dueDate: "May 20, 2025",
        estimated: 5,
        logged: 0,
        progress: 0,
        collaborators: [
          { name: "Mark Carlo", src: avatar1 },
          { name: "Sophia Lee", src: avatar2 },
        ],
        description:
          "Prepare rehearsal notes for the string section, including bowing marks, cue points, and dynamic adjustments.",
        sessionActivity: [],
        timeTracking: { total: 5, logged: 0, remaining: 5 },
      },
    ],
  },
]

/** Flat My Tasks list for the current user (Figma 40004314-9104). */
export const MY_TASKS = [
  {
    id: 201,
    title: "Review Sound Mix - Act 2",
    status: "In Progress",
    dueDate: "May 25, 2025",
    estimated: 4,
    logged: 2.5,
    action: "continue",
    completed: false,
  },
  {
    id: 202,
    title: "Compose Opening Theme",
    status: "Completed",
    dueDate: "May 18, 2025",
    estimated: 8,
    logged: 7.5,
    action: "done",
    completed: true,
  },
  {
    id: 203,
    title: "Record Vocal Tracks",
    status: "In Progress",
    dueDate: "May 28, 2025",
    estimated: 6,
    logged: 3,
    action: "start",
    completed: false,
  },
  {
    id: 204,
    title: "Edit Percussion Arrangement",
    status: "Not Started",
    dueDate: "Jun 02, 2025",
    estimated: 5,
    logged: 0,
    action: "start",
    completed: false,
  },
  {
    id: 205,
    title: "Mix Final Master Track",
    status: "Not Started",
    dueDate: "Jun 08, 2025",
    estimated: 10,
    logged: 0,
    action: "start",
    completed: false,
  },
  {
    id: 206,
    title: "Score Review with Director",
    status: "In Progress",
    dueDate: "May 30, 2025",
    estimated: 3,
    logged: 1.5,
    action: "start",
    completed: false,
  },
  {
    id: 207,
    title: "Sound Design - Scene 4",
    status: "Not Started",
    dueDate: "Jun 12, 2025",
    estimated: 4,
    logged: 0,
    action: "start",
    completed: false,
  },
]

export const CONVERSATIONS = [
  {
    id: 1,
    title: "Maria",
    isGroup: false,
    participants: [{ name: "Maria", avatar: avatar2, role: "Sound Tech" }],
    lastMessage: {
      sender: "Maria",
      text: "Sounds good, see you there!",
      time: "Now",
    },
    messages: [
      {
        sender: "Maria",
        avatar: avatar2,
        time: "Now",
        isMe: false,
        text: "Sounds good, see you there!",
      },
    ],
    attachments: [],
  },
  {
    id: 2,
    title: "Main Stage Sound Check & Lineup",
    isGroup: true,
    isPrivate: true,
    participants: [
      { name: "Jordan Lee", avatar: avatar1, role: "Sound Manager" },
      { name: "Maria", avatar: avatar2, role: "Sound Tech" },
      { name: "David", avatar: avatar3, role: "Lighting" },
      { name: "Lena", avatar: avatar4, role: "Stage" },
    ],
    lastMessage: {
      sender: "Jordan",
      text: "Hey Crew...",
      time: "Now",
    },
    messages: [
      {
        sender: "Jordan Lee",
        avatar: avatar1,
        role: "Sound Manager",
        time: "2m ago",
        isMe: false,
        text: "Hey crew,\n\nQuick update on Main Stage setup for tonight's headliner. We confirmed the venue layout, artist riders, and sound check schedule. Please review the attached stage plot and confirm your roles.\n\nSound check starts at 4:00 PM. Stage setup begins at 2:30 PM. Let's confirm the final lineup order and artist changeover times.",
        signOff: "Thanks,",
        signatureName: "Jordan Lee",
        signatureTitle: "Sound Manager, Dallas Live Arts",
        attachment: {
          name: "Festival-Stage-Layout.pdf",
          size: "1.8 MB",
          type: "PDF",
        },
        reactions: [{ emoji: "👍", count: 2 }],
      },
    ],
    attachments: [],
  },
  {
    id: 3,
    title: "David",
    isGroup: false,
    participants: [{ name: "David", avatar: avatar3, role: "Lighting" }],
    lastMessage: {
      sender: "David",
      text: "I'll send the files shortly...",
      time: "Yesterday",
    },
    messages: [
      {
        sender: "David",
        avatar: avatar3,
        time: "Yesterday",
        isMe: false,
        text: "I'll send the files shortly...",
      },
    ],
    attachments: [],
  },
  {
    id: 4,
    title: "Lena",
    isGroup: false,
    participants: [{ name: "Lena", avatar: avatar4, role: "Stage" }],
    lastMessage: {
      sender: "Lena",
      text: "Can we push the..",
      time: "Yesterday",
    },
    messages: [
      {
        sender: "Lena",
        avatar: avatar4,
        time: "Yesterday",
        isMe: false,
        text: "Can we push the setup time to 3pm?",
      },
    ],
    attachments: [],
  },
]
